const socketData = (state = [], action) => { 
    switch(action.type){  
        case 'STORE_SOCKET':
              return state = action.payload;   
        case 'DELETE_SOCKET':
              return state = [];   
        default:
              return state;

    }
};

export default socketData;